import * as React from "react";
import { Provider, useDispatch } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { createCommonStore } from "~/common/createCommonStore";
import { BasePortfolio } from "~/normalizr/PortfoliosSchema";
import { getPortfoliosModule, updatePortfolios } from "~/Redux/portfolios";
import { PortfolioDropdown } from "./PortfolioDropdown";

type Props = React.ComponentProps<typeof PortfolioDropdown> & { portfolios: BasePortfolio[] };

const Portfolios: React.FC<Props> = ({ portfolios, ...props }) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(updatePortfolios(portfolios));
    }, []);

    return <PortfolioDropdown {...props} />;
};

export const DynamicPortfolioDropdown: React.FC<Props> = props => {
    const store = createCommonStore();

    return (
        <Provider store={store}>
            <DynamicModuleLoader modules={[getPortfoliosModule()]}>
                <Portfolios {...props} />
            </DynamicModuleLoader>
        </Provider>
    );
};
